module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-page"
  }, [(_vm.showH !== 'false') ? _c('div', {
    staticClass: "title-content"
  }, [(_vm.titleCenter) ? _c('div', {
    staticClass: "title-center"
  }, [_vm._v(_vm._s(_vm.title))]) : _c('div', {
    staticClass: "title"
  }, [_c('label', [_vm._v(_vm._s(_vm.title))]), (_vm.titleBg) ? _c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../../assets/notification_title_bg.png"),
      "alt": ""
    }
  }) : _vm._e()])]) : _vm._e(), _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2), (_vm.showMore) ? _c('el-button', {
    staticClass: "footer todoBtn",
    on: {
      "click": _vm.getMore
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.footer))]), _c('i', {
    staticClass: "el-icon-arrow-down"
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80faf2e0","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Container.vue
// module id = 727
// module chunks = 0 1 3 7 9 12 13 16 18 19 20 24 25 26 27 28 29 30 31 32 33 34 35 36 38 39 40 41 42 43 44